import { render, staticRenderFns } from "./OuterGlowEffect.vue?vue&type=template&id=4409372e"
import script from "./OuterGlowEffect.vue?vue&type=script&lang=js"
export * from "./OuterGlowEffect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4409372e')) {
      api.createRecord('4409372e', component.options)
    } else {
      api.reload('4409372e', component.options)
    }
    module.hot.accept("./OuterGlowEffect.vue?vue&type=template&id=4409372e", function () {
      api.rerender('4409372e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/OuterGlowEffect.vue"
export default component.exports